import AuthService from "../../services/auth.service";
import router from "../../router";

const state = {
    user: localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")),
    refreshToken :localStorage.getItem("refresh_token"),
};

const getters = {
    isAuthenticated: (state) => !!state.user
};

const mutations = {
    auth_success(state, user) {
        state.user = user
    },
    auth_clear(state) {
        state.user = null
    },
};

const actions = {

    async login({commit}, {email, password}) {
        var user = await AuthService.login(email, password);
        commit("auth_success", user);
        router.push(router.history.current.query.redirect || "/");
    },
    async refreshToken({commit}) {
        var user = await AuthService.refreshToken();
        commit("auth_success", user);
    },
    logout({commit}) {
        router.push("/login")
        AuthService.logoutService();
        commit("auth_clear");
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
